import {
    CREATE_PROGRAM_CONSTRAINT_REQUEST,
    CREATE_PROGRAM_CONSTRAINT_SUCCESS,
    CREATE_PROGRAM_CONSTRAINT_FAILURE,
    DELETE_PROGRAM_CONSTRAINT_REQUEST,
    DELETE_PROGRAM_CONSTRAINT_SUCCESS,
    DELETE_PROGRAM_CONSTRAINT_FAILURE,
    FETCH_SINGLE_PROGRAM_CONSTRAINT_REQUEST,
    FETCH_SINGLE_PROGRAM_CONSTRAINT_SUCCESS,
    FETCH_SINGLE_PROGRAM_CONSTRAINT_FAILURE,
    FETCH_PROGRAM_CONSTRAINT_REQUEST,
    FETCH_PROGRAM_CONSTRAINT_SUCCESS,
    FETCH_PROGRAM_CONSTRAINT_FAILURE,
    UPDATE_PROGRAM_CONSTRAINT_REQUEST,
    UPDATE_PROGRAM_CONSTRAINT_SUCCESS,
    UPDATE_PROGRAM_CONSTRAINT_FAILURE,
    RESET_PROGRAM_CONSTRAINT_INFO,
    CREATE_PROGRAM_CONSTRAINT_FORM,
    UPDATE_PROGRAM_CONSTRAINT_FORM
} from './programConstraint.actionsType';

export const PROGRAM_CONSTRAINT = 'programConstraint';

let initialState = {
    loading: false,
    programConstraintList: [],
    programConstraintform: {
        fldDefaultSequence: true,
        fldNotPossibleSequence: false
    },
    selectedState: {},
    errorMessage: ''
};

export let programConstraintReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROGRAM_CONSTRAINT_REQUEST:
        case CREATE_PROGRAM_CONSTRAINT_REQUEST:
        case UPDATE_PROGRAM_CONSTRAINT_REQUEST:
        case FETCH_SINGLE_PROGRAM_CONSTRAINT_REQUEST:
        case DELETE_PROGRAM_CONSTRAINT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROGRAM_CONSTRAINT_SUCCESS:
            return {
                ...state,
                loading: false,
                programConstraintList: updatePayload
            };
        case CREATE_PROGRAM_CONSTRAINT_SUCCESS:
            return {
                ...state,
                loading: false,
                programConstraintform: {
                    fldDefaultSequence: true,
                    fldNotPossibleSequence: false
                }
            };
        case UPDATE_PROGRAM_CONSTRAINT_SUCCESS:
            return {
                ...state,
                loading: false,
                programConstraintform: {
                    fldDefaultSequence: true,
                    fldNotPossibleSequence: false
                }
            };
        case FETCH_SINGLE_PROGRAM_CONSTRAINT_SUCCESS:
            return {
                ...state,
                loading: false,
                programConstraintform: {
                    ...updatePayload
                }
            };
        case DELETE_PROGRAM_CONSTRAINT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_PROGRAM_CONSTRAINT_INFO:
            return {
                ...state,
                programConstraintform: {
                    fldDefaultSequence: true,
                    fldNotPossibleSequence: false
                }
            };
        case CREATE_PROGRAM_CONSTRAINT_FORM:
        case UPDATE_PROGRAM_CONSTRAINT_FORM:
            return {
                ...state,
                loading: false,
                programConstraintform: {
                    ...state.programConstraintform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROGRAM_CONSTRAINT_FAILURE:
        case CREATE_PROGRAM_CONSTRAINT_FAILURE:
        case UPDATE_PROGRAM_CONSTRAINT_FAILURE:
        case FETCH_SINGLE_PROGRAM_CONSTRAINT_FAILURE:
        case DELETE_PROGRAM_CONSTRAINT_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
